(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("tenantFeaturesResource", ["$resource", tenantFeaturesResource]);
    function tenantFeaturesResource($resource) {
        return $resource("/api/tenantFeatures/:action/:actionValue", { action: "@action", actionValue: "@actionValue" }, {
            getCECreditsView: {
                method: "GET",
                params: { action: "CECreditsView" }
            },
            saveCECreditsView: {
                method: "POST",
                params: { action: "CECreditsView" }
            },
            getIsTenantSelfRegistrationEnabled: {
                method: "GET",
                params: { action: "isTenantSelfRegistrationEnabled" }
            },
            getIsTenantStorefrontEnabled: {
                method: "GET",
                params: { action: "isTenantStorefrontEnabled" }
            },
            getStorefrontInventoryAssignToOrganization: {
                method: "GET",
                params: { action: "storefrontInventoryAssignToOrganization" }
            },
            getStorefrontInventoryAssignToOrganizationForCurrentUser: {
                method: "GET",
                params: { action: "storefrontInventoryAssignToOrganizationForCurrentUser" }
            },
            getSelfRegistrationSettingsViewModel: {
                method: "GET",
                params: { action: "selfRegistrationSettingsViewModel" }
            },
            updateSelfRegistrationSettings: {
                method: "POST",
                params: { action: "updateSelfRegistrationSettings" }
            },
            getCustomRegistrationFieldsViewModel: {
                method: "GET",
                params: { action: "customRegistrationFieldsViewModel" }
            },
            updateCustomRegistrationFields: {
                method: "POST",
                params: { action: "updateCustomRegistrationFields" }
            },
            getTenantStorefront: {
                method: "GET",
                params: { action: "tenantStorefront" }
            },
            updateTenantCatalog: {
                method: "POST",
                params: { action: "tenantCatalog" }
            },
            updateForums: {
                method: "POST",
                params: { action: "forums" }
            },
            updateTenantStorefront: {
                method: "POST",
                params: { action: "tenantStorefront" }
            },
            updateTenantStorefrontReceipt: {
                method: "POST",
                params: { action: "tenantStorefrontReceipt" }
            },
            getTenantStorefrontTierPrices: {
                isArray: true,
                method: "GET",
                params: { action: "tenantStorefront", actionValue: "tierPrices" }
            },
            getTenantRegistrationQuestionsViewModel: {
                method: "GET",
                params: { action: "tenantRegistrationQuestionsViewModel" }
            },
            getTenantRegistrationQuestionViewModel: {
                method: "GET",
                params: { action: "tenantRegistrationQuestionViewModel" }
            },
            saveRegistrationQuestion: {
                method: "POST",
                params: { action: "saveRegistrationQuestion" }
            },
            saveRegistrationQuestionsOrder: {
                method: "POST",
                params: { action: "saveRegistrationQuestionsOrder" }
            },
            saveRegistrationQuestionState: {
                method: "POST",
                params: { action: "saveRegistrationQuestionState" }
            },
            updatePathReassignEnabled: {
                method: "POST",
                params: { action: "updatePathReassignEnabled" }
            },
            updateWorkHistory: {
                method: "POST",
                params: { action: "updateWorkHistory" }
            },
            updateHideEvaluatorId: {
                method: "POST",
                params: { action: "updateHideEvaluatorId" }
            },
        });
    }
}());
